import React from 'react';
import PropTypes from 'prop-types';

import AdminPageContainer from '../common/AdminPageContainer';
import AdminPageTitle from '../common/AdminPageTitle';
import AdminErrorMessage from '../common/AdminErrorMessage';
import Loader from '../../common/loader/Loader';
import ConfirmationModal from '../../common/modals/ConfirmationModal';
import { DeleteButton } from '../common/Buttons';

import useAdminCourseRequestsPageState from './useAdminCourseRequestsPageState';

const AdminCourseRequestsPage = props => {
  const { status, data, openDeleteConfirmation, deleteConfirmation } = useAdminCourseRequestsPageState(props.history);

  return (
    <AdminPageContainer>
      <AdminPageTitle title="Requests sent from courses page" />

      <Loader isVisible={status.isLoading} />

      <AdminErrorMessage isVisible={status.isError && !status.isLoading} />

      <ConfirmationModal state={deleteConfirmation} />

      {!status.isError && !status.isLoading && (
        <div className="mt-20px">
          {data.map(request => (
            <div key={request._id} className="admin-table-row align-items-center">
              <div className="is-flex align-items-center">
                <div className="ml-20px">
                  <p className="admin-table-row-title">{request.email}</p>
                  <p>
                    Name: <strong>{request.name}</strong>; Phone: <strong>{request.phone}</strong>
                  </p>
                  <p>
                    Course name: <strong>{request.course.name}</strong>; Price: <strong>{request.course.price}</strong>
                  </p>
                  <p className="admin-text-sm">
                    at: <strong>{request.createdAt.toString()}</strong>; id: <strong>{request._id}</strong>; courseId:{' '}
                    <strong>{request.courseId}</strong>
                  </p>
                </div>
              </div>
              <DeleteButton onClick={openDeleteConfirmation(request._id)} className="ml-10px mt-10px" />
            </div>
          ))}
        </div>
      )}
    </AdminPageContainer>
  );
};

AdminCourseRequestsPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AdminCourseRequestsPage;
